import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
  FormControlLabel,
  Checkbox
} from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import { v4 as uuidv4 } from "uuid"
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb"
import {
  setSurveys,
  setSurveyGroups,
  setSurveyQuestions
} from "../../../redux/slices/configSlice"
import { RootState, useAppThunkDispatch } from "../../../redux/store"
import { useHistory, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import React, { useState, useEffect, useReducer } from "react"
import { PATH } from "../../../constants/paths"
import { getTranslations, setWeekFieldError } from "src/utils/helper"
import {
  FIELD_DELIMITER,
  RECORD_DELIMITER,
  BANNER_TYPE_VALUES
} from "src/utils/constants"

import { Loader } from "src/utils/reusables/reusable"
import { SURVEYS_FILE_TITLES } from "src/constants/outputFiles"
import { useTranslation } from "react-i18next"
import { Translates } from "src/i18n/i18n"
import { reducer, updateWarnOnTabChangeToStore } from "../helper"
import { alertMsgShow, emptyAlert } from "../FunctionHelper"
import GroupsAndQuestions from "./GroupsAndQuestions"
import { ConfigDataHook } from "src/hooks/configurationFileData"

interface INewSurvey {
  SurveyId: string
  Name: string
  Description: string
  AvailableOnlyAtClose: boolean
  RequiredSurvey: boolean
  BannerType: any
  BannerTitle: string
  BannerText: string

  // FileName: string
  // ColumnsToSuppress: string
  // FileType: string
  // FieldDelimiter: string
  // RecordDelimiter: string
  // HasHeaderRecord: boolean
  // Prompts?: any
  // SQL?: any
  // SubTotals: any
  // GrandTotals: any
  // OtherFieldDelimiter: string
  // OtherRecordDelimiter: string
  // AsciiCharValue: any
  // Destination: any
  // Notification: any
}

let alertVisible: boolean = false
let alertMsg = emptyAlert
const CreateEditSurveys = () => {
  const { t } = useTranslation<any>()
  const location = useLocation() as any
  const [, setReload] = useReducer(reducer, false)
  let search = window.location.search || ""
  const locationState = { ...location.state }
  const {
    config: { surveyGroups, surveyQuestions }
  } = ConfigDataHook()
  let isEdit = locationState.isEdit
  const [form, setForm] = React.useState<INewSurvey>({
    SurveyId: "",
    Name: "",
    Description: "",
    AvailableOnlyAtClose: true,
    RequiredSurvey: true,
    BannerType: 0,
    BannerTitle: "",
    BannerText: ""

    // FileName: "",
    // ColumnsToSuppress: "",
    // FileType: "",
    // RecordDelimiter: "{CR}{LF}",
    // FieldDelimiter: "",
    // HasHeaderRecord: false,
    // SubTotals: [],
    // GrandTotals: [],
    // OtherFieldDelimiter: "",
    // OtherRecordDelimiter: "",
    // AsciiCharValue: "",
    // Destination: {},
    // Notification: {}
  } as INewSurvey)
  const [errorMsg, setErrorMsg] = useState(false)
  const [weekIVFields, setWeekIVFields] = useState({
    Name: "",
    FileName: ""
  })
  const dispatch = useAppThunkDispatch()
  const history = useHistory()
  const configData = useSelector((state: RootState) => state.config)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (locationState.data)
      setForm({
        ...locationState.data
      })

    //eslint-disable-next-line
  }, [locationState.data])

  const formAndReduxVariableSet = () => {
    setForm({
      ...locationState.data
    })
    dispatch(setSurveyGroups(locationState?.data?.surveyGroups || []))
    dispatch(setSurveyQuestions(locationState?.data?.surveyQuestions || []))
  }
  useEffect(() => {
    const locationState = { ...location.state }
    setLoading(true)

    if (locationState.isEdit === true) {
      formAndReduxVariableSet()
    }

    setLoading(false)
    //eslint-disable-next-line
  }, [])

  const getLookupBreadcrumb = () => {
    const breadcrumbLookUP = {
      custLinks: { "@landingPage": `configuration/surveys` },
      mapObj: {
        "@landingPage": `${getTranslations(t, Translates.Surveys)}`,
        Surveys: getTranslations(
          t,
          locationState.isEdit
            ? `${getTranslations(t, Translates.Edit_Survey)}`
            : `${getTranslations(t, Translates.New_Survey)}`
        )
      }
    }
    return breadcrumbLookUP
  }

  const getBreadcrumbConfig = () => {
    let currentPath: string = "##configuration##/@landingPage/Surveys"
    let bConfig: any = {
      currentPath,
      ...getLookupBreadcrumb(),
      showHomeIcon: false
    }
    return bConfig
  }

  const onFormChange = e => {
    // updateWarnOnTabChangeToStore(true)
    const val = e.target.value ?? ""

    if (e.target.name === "Name") {
      const _SurveyName = configData.Surveys.map(m => m.Name)
      if (_SurveyName.includes(val)) {
        setErrorMsg(true)
        setForm({ ...form, [e.target.name]: val })
      } else {
        setErrorMsg(false)
        setForm({ ...form, [e.target.name]: val })
      }
      setWeekFieldError({ setWeekIVFields, val, t, field: e.target.name })
    } else if (e.target.name === "BannerType") {
      const resetBanner: any = {}
      if (val === 0) {
        resetBanner.BannerText = ""
        resetBanner.BannerTitle = ""
      }
      setForm({
        ...form,
        ...resetBanner,
        BannerType: val
      })
    } else if (e.target.name === "availableOnlyAtClose") {
      setForm({ ...form, AvailableOnlyAtClose: e.target.checked })
    } else if (e.target.name === "BannerTitle") {
      setForm({ ...form, BannerTitle: val })
    } else if (e.target.name === "BannerText") {
      setForm({ ...form, BannerText: val })
    } else if (e.target.name === "requiredSurvey") {
      setForm({ ...form, RequiredSurvey: e.target.checked })
    } else if (e.target.name) {
      setForm({ ...form, [e.target.name]: val })
    }
  }

  const payloadPreparation = () => {
    const _sortOrder =
      configData?.Surveys?.length > 0
        ? configData?.Surveys?.reduce(
            (a: any, b: { SortOrder: number }) => Math.max(b.SortOrder) || a,
            0
          )
        : 0
    return {
      SurveyId: location.state?.isEdit
        ? location.state?.data?.SurveyId
        : uuidv4(),
      Name: form.Name,
      Description: form.Description,
      RequiredSurvey: form.RequiredSurvey,
      AvailableOnlyAtClose: form.AvailableOnlyAtClose,
      BannerType: form.BannerType,
      BannerTitle: form.BannerTitle,
      BannerText: form.BannerText,
      SortOrder: location.state?.isEdit
        ? location.state?.data?.SortOrder
        : _sortOrder + 1,
      surveyGroups,
      surveyQuestions
    }
  }
  const onSaveClick = () => {
    let sortID
    // get the columns suppressed from the columns object

    if (location.state?.isEdit !== true) {
      sortID = location.pathname?.split("/")[3]
      const _SurveyName = configData?.Surveys.map(m => m.Name)
      if (_SurveyName.includes(form.Name)) {
        setErrorMsg(true)
        return null
      }
    }
    setErrorMsg(false)
    const _item = payloadPreparation()

    let _dt = [] as any
    if (location.state?.isEdit) {
      _dt = configData?.Surveys.map(m =>
        m.SortOrder === _item.SortOrder ? { ...m, ..._item } : { ...m }
      )
    } else {
      _dt = [...(configData?.Surveys || []), _item]
    }
    dispatch(setSurveys(_dt))
    onCancelClick()
  }

  const onCancelClick = () => {
    updateWarnOnTabChangeToStore(false)
    setTimeout(() => {
      history.push(PATH.SURVEYS + search)
    })
  }

  const checkValidation = () => {
    let reqFields = {}

    const { Name } = form

    Object.assign(reqFields, { Name })
    return checkRestForm(reqFields)
  }

  const checkRestForm = rest =>
    Object.values(rest).some(s => s === "" || s === null || errorMsg === true)

  const getNameError = () => {
    if (errorMsg) {
      return getTranslations(t, "Survey_Name_already_exists")
    } else if (weekIVFields.Name) {
      return weekIVFields.Name
    }
    return ""
  }

  return (
    <>
      <div>
        <div className="main-toolbar">
          <div className="main-container">
            <Grid container>
              <Grid item sm={12}>
                <div className="custom-breadcrumb CP">
                  <BreadCrumb
                    customPath={"New Survey"}
                    breadCrumbInfo={getBreadcrumbConfig()}
                    renderedPage={""}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        {loading ? (
          Loader()
        ) : (
          <Grid container className="main-container">
            <Grid item xs={12} sm={12} className="mb-8">
              <Grid container>
                <Grid item xs={12} sm={3}>
                  <label className="form-control__label mb-3">
                    {getTranslations(t, Translates.GENERAL)}
                  </label>
                  <div className="text-box">
                    {" "}
                    <TextField
                      fullWidth
                      label={`${getTranslations(t, Translates.Name)}*`}
                      variant="filled"
                      autoSave="false"
                      autoComplete="off"
                      className="custom-form-control"
                      onChange={e => onFormChange(e)}
                      name="Name"
                      inputProps={{ maxLength: 50 }}
                      value={form.Name || ""}
                      error={!!errorMsg || !!weekIVFields.Name}
                      helperText={getNameError()}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={5}>
                  <TextField
                    multiline
                    fullWidth
                    label={`${getTranslations(t, Translates.Description)}`}
                    rows={3}
                    variant="filled"
                    autoSave="false"
                    autoComplete="off"
                    className="custom-form-control"
                    onChange={e => onFormChange(e)}
                    name="Description"
                    value={form.Description || ""}
                    inputProps={{ maxLength: 250 }}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12} sm={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        data-testid="RequiredSurveyCheckField"
                        name="requiredSurvey"
                        checked={form.RequiredSurvey}
                        defaultChecked={false}
                        className="custom-check light"
                        onChange={e => onFormChange(e)}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={getTranslations(t, Translates.Required)}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        data-testid="AvailableOnlyAtCloseCheckField"
                        name="availableOnlyAtClose"
                        checked={form.AvailableOnlyAtClose}
                        defaultChecked={false}
                        className="custom-check light"
                        onChange={e => onFormChange(e)}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={getTranslations(
                      t,
                      Translates.Available_Only_At_Close
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <Grid container>
                    <Grid item xs={12} sm={3}>
                      <FormControl
                        variant="filled"
                        className="custom-form-control select"
                      >
                        <InputLabel
                          id="banner-type-checkbox-label"
                          variant="filled"
                        >
                          {getTranslations(t, Translates.Banner_Type)}
                        </InputLabel>

                        <Select
                          id="banner-type-checkbox"
                          data-testid="bannerTypeSelectField"
                          value={form.BannerType}
                          name="BannerType"
                          onChange={e => onFormChange(e)}
                        >
                          <MenuItem
                            key={"banner-type-none"}
                            value={0}
                            className="dropdown-list"
                          >
                            <small>{getTranslations(t, Translates.None)}</small>
                          </MenuItem>
                          {BANNER_TYPE_VALUES.map((name: any) => (
                            <MenuItem
                              key={name}
                              value={name}
                              className="dropdown-list"
                            >
                              <small>{getTranslations(t, name)}</small>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {!!form.BannerType && (
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <div className="text-box">
                      {" "}
                      <TextField
                        fullWidth
                        label={`${getTranslations(t, Translates.Banner_Title)}`}
                        variant="filled"
                        autoSave="false"
                        autoComplete="off"
                        className="custom-form-control"
                        onChange={e => onFormChange(e)}
                        name="BannerTitle"
                        value={form.BannerTitle || ""}
                      />
                    </div>
                  </Grid>
                </Grid>
              )}
              {!!form.BannerType && (
                <Grid container>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      multiline
                      fullWidth
                      label={`${getTranslations(t, Translates.Banner_Text)}`}
                      rows={3}
                      variant="filled"
                      autoSave="false"
                      autoComplete="off"
                      className="custom-form-control"
                      onChange={e => onFormChange(e)}
                      name="BannerText"
                      value={form.BannerText || ""}
                      inputProps={{ maxLength: 255 }}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm={12}>
              <GroupsAndQuestions
                isParentEdit={isEdit}
                form={{
                  ...form
                  // customerPortalCheck: customerPortalCheck,
                  // selectedOption: selectedOption,
                  // chips: chips
                }}
                surveyName={form.Name}
                setForm={setForm}
              />
            </Grid>

            <Grid item xs={12}>
              <div className="inner-view__footer">
                <Button
                  variant="text"
                  className="primary-btn cancel-btn mr-5"
                  onClick={() => onCancelClick()}
                >
                  {getTranslations(t, Translates.Cancel)}
                </Button>
                <Button
                  variant="contained"
                  className="primary-btn"
                  disabled={
                    checkValidation() === true ||
                    // !isValid ||
                    // !isNotificationValid ||
                    Object.values(weekIVFields).some(s => s || s !== "")
                  }
                  onClick={() => onSaveClick()}
                >
                  {getTranslations(t, Translates.Save)}
                </Button>
              </div>
            </Grid>
          </Grid>
        )}
      </div>
      <Grid container>
        {alertVisible ? <>{alertMsgShow(alertMsg)}</> : null}
      </Grid>
    </>
  )
}

export default CreateEditSurveys
